import React from 'react'
import './utils.css'
import { M_InputTextField, M_SimpleTable } from 'src/M_Components'

export default function TableCustomOffice({ dictCustomOfficeDict }) {
  const columns = [
    { label: 'Number', type: 'int' },
    { label: 'Document Type', type: 'textfield' },
    { label: 'Despatch number', type: 'textfield' },
    { label: 'Customs office', type: 'textfield' },
    { label: 'Customs Status', type: 'textfield' },
    { label: 'Date', type: 'date' },
  ]

  const NumberStyle = {
    fontWeight: 'bolder',
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingRight: '8px',
    paddingLeft: '7px',
    display: 'flex'
  }

  const dynamicColumns = columns.map((elem, index) => {
    if (elem.label === 'Number') {
      return {

        header: '#',
        body: (data) => {
          
          return (
            <span style={data?.shipmentChanged?.includes('CustomsOfficeId') ?
              {
                ...NumberStyle,
                ...styleNew(elem)
              } :
              NumberStyle
            }>
              {/* {dictCustomOfficeDict.findIndex(custElement => custElement.id === data.id) + 1} */}
              {data.id}
            </span>
          )
        }
      }
    }
    return {
      key: index,
      field: elem.label,
      header: elem.label,
      body: (data) => elemBody(data, elem),
    }

  })

  const styleNew = (columnInfo) => {
    return {
      borderTop: '2px solid var(--color-green)',
      borderBottom: '2px solid var(--color-green)',
      borderRight: columnInfo?.label === 'Date' && '2px solid var(--color-green)',
      borderLeft: columnInfo?.label === 'Number' && '2px solid var(--color-green)',
      borderTopRightRadius: columnInfo?.label === 'Date' && '5px',
      borderBottomRightRadius: columnInfo?.label === 'Date' && '5px',
      borderTopLeftRadius: columnInfo?.label === 'Number' && '5px',
      borderBottomLeftRadius: columnInfo?.label === 'Number' && '5px',
    }
  }

  const elemBody = (data, columnInfo) => {
    console.log(data, columnInfo)
    return (
      <div
        style={
          data?.shipmentChanged?.includes('CustomsOfficeId') ?
            styleNew(columnInfo)
            : {}
        }
      >
        <M_InputTextField
          padding={'0px'}
          paddingLeft={'5px'}
          height={'26px'}
          margin='3px'
          draggable={false}
          className='inputColumnsCustoms'
          type="text"
          value={data[columnInfo.label]}
          disabled
          size={'auto'}
          color={data?.shipmentChanged.includes(columnInfo.label) && !data?.shipmentChanged?.includes('CustomsOfficeId') ? 'var(--color-yellow)' : 'var(--color-white)'}
          disabledColor={data?.shipmentChanged.includes(columnInfo.label) && !data?.shipmentChanged?.includes('CustomsOfficeId') ? 'var(--color-yellow)' : 'var(--color-white)'}
        />
      </div >

    )
  }

  return (
    <>
      {dictCustomOfficeDict.length !== 0 ?
        <M_SimpleTable
          rows={dictCustomOfficeDict}
          columns={dynamicColumns}
          className={'BLTable'}
        />
        : null}
    </>
  )
}